import { useEffect, useState } from "react";
import api from "./api";

// Moduli attivabili/disattivabili dal Superadmin per ogni studio.
export const MODULI_MENU = [
  { key: "agenda", label: "Agenda" }, { key: "archivio", label: "Archivio Pratiche" },
  { key: "lettere", label: "Gestione Lettere" }, { key: "allegati-studio", label: "Allegati Studio" },
  { key: "email", label: "Email" }, { key: "pec", label: "PEC" }, { key: "messaggi", label: "Messaggistica" },
  { key: "rubrica", label: "Rubrica" },
  { key: "contabilita", label: "Contabilità" }, { key: "riepilogo-segnalatori", label: "Riepilogo Segnalatori" },
  { key: "proforme", label: "Fatture Proforma" },
];
export const MODULI_PRATICA = ["Quantifica", "Ricostruisci", "Periziatore", "PML", "Offerta", "Quietanza", "PEC", "Email", "Lettere",
  "Allegati", "Web", "Reclamo", "Anti frode", "Costi", "Fattura", "Proforma", "SMS", "Messaggi", "Comunicazioni"]
  .map((l) => ({ key: `pratica:${l}`, label: l }));

let cache = null;
const listeners = new Set();
const refresh = () => api.get("/studio/moduli").then(({ data }) => {
  cache = new Set(data?.disattivati || []);
  listeners.forEach((fn) => fn(cache));
}).catch(() => {});

// Set dei moduli disattivati per lo studio corrente (aggiornato al focus della finestra e ogni minuto).
export function useDisabledModules(enabled = true) {
  const [off, setOff] = useState(cache || new Set());
  useEffect(() => {
    if (!enabled) return undefined;
    listeners.add(setOff);
    if (cache) setOff(cache);
    refresh();
    const onFocus = () => refresh();
    window.addEventListener("focus", onFocus);
    const t = setInterval(refresh, 60000);
    return () => { listeners.delete(setOff); window.removeEventListener("focus", onFocus); clearInterval(t); };
  }, [enabled]);
  return enabled ? off : new Set();
}

export const refreshModules = refresh;
